/* Variant pill click handler for product cards (.np-card) — uses event delegation so dynamically added cards work too. */
(function () {
  if (window.__npCardBound) return;
  window.__npCardBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.np-card__variant-pill');
    if (!btn || btn.disabled) return;

    var container = btn.closest('.np-card__variants');
    if (!container) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var form = container.closest('form');
    if (form) {
      var hidden = form.querySelector('input.np-card__variant-hidden, input[name="id"]');
      if (hidden) hidden.value = variantId;
    }

    container.querySelectorAll('.np-card__variant-pill').forEach(function (b) {
      b.classList.remove('np-card__variant-pill--active');
    });
    btn.classList.add('np-card__variant-pill--active');
  });
})();
